export const selectAuthData = (state) => state.auth;
